"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentYearAndUpdateToNextInDecember = exports.setAddItemsToServiceCookies = exports.getAddItemsToServiceCookies = exports.clearAddItemsToServiceCookies = exports.scrollToTop = exports.showBrandSelector = exports.convertDateTimeToTimeZone = exports.getDetailDateFormate = exports.getLoggedInUserFullNameFromToken = exports.toFixedNumber = exports.getFormattedDateInUtc = exports.getRemainingTimeToOrder = exports.getSsspRedirectionLink = exports.getAdminPortalRedirectionLink = exports.handleDayLightSavings = exports.getEndOfDay = exports.getStartOfDay = exports.getTargetedUserData = exports.formatMobileNumber = exports.getIsAccountOwner = exports.isGuestUser = exports.isUserAdminOrSuperAdmin = exports.isFlexiBrandUser = exports.getLoggedInUserBrandId = exports.isLoggedUserEnabledForLegacyRouting = exports.isCurrentUserSupplier = exports.isCurrentUserCommsAdmin = exports.isCurrentUserOffshoreAdmin = exports.isCurrentUserAdminOrSuperAdmin = exports.toLocalDate = exports.setImpersonatingBrandId = exports.getImpersonatingBrandId = exports.isImpersonating = exports.addMonthsToDate = exports.formatDate = exports.setStateByRole = exports.getJwtToken = exports.getCurrentUserId = exports.getIsModernOrderingEnabled = exports.setIsModernOrderingEnabled = exports.setUserKey = exports.getUserKey = exports.downloadCSV = exports.getTargetUserId = exports.convertFromLocalToUtc = exports.convertFromUtcToLocal = exports.FormatToCurrency = exports.isLoadingInWebView = exports.createId = void 0;
exports.isSafari = isSafari;
var js_cookie_1 = __importDefault(require("js-cookie"));
var Constants = __importStar(require("../Constants"));
var moment_1 = __importDefault(require("moment"));
var store2_1 = __importDefault(require("store2"));
var auth_1 = require("@aws-amplify/auth");
var dayjs_1 = __importDefault(require("dayjs"));
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
var timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
var CookieUtils_1 = require("../CookieUtils");
var UserRoles_1 = require("../User/UserRoles");
var brandId_1 = require("../types/brandId");
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
(0, moment_1.default)().calendar({
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    nextWeek: 'dddd',
    lastDay: '[Yesterday]',
    lastWeek: '[Last] dddd',
    sameElse: 'dddd, Do MMM YYYY',
});
var createId = function (length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
exports.createId = createId;
var isLoadingInWebView = function () {
    var _a;
    if (js_cookie_1.default.get(Constants.IsWebView) != null) {
        return ((_a = js_cookie_1.default.get(Constants.IsWebView)) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true';
    }
    return false;
};
exports.isLoadingInWebView = isLoadingInWebView;
var FormatToCurrency = function (num) {
    if (!num) {
        return '$0.00';
    }
    // @ts-ignore
    String.prototype.insert = function (index, string) {
        if (index > 0) {
            return this.substring(0, index) + string + this.substr(index);
        }
        return string + this;
    };
    // @ts-ignore
    Number.prototype.toLocaleFixed = function (fixedDecimalPlaces) {
        return this.toLocaleString(undefined, {
            minimumFractionDigits: fixedDecimalPlaces,
            maximumFractionDigits: fixedDecimalPlaces,
        });
    };
    // @ts-ignore
    var formattedNum = num.toLocaleFixed(2);
    return formattedNum.toString().insert(formattedNum < 0 ? 1 : 0, '$');
};
exports.FormatToCurrency = FormatToCurrency;
var convertFromUtcToLocal = function (date) {
    return (0, moment_1.default)(date)
        .local()
        .format('DD/MM/YYYY');
};
exports.convertFromUtcToLocal = convertFromUtcToLocal;
var convertFromLocalToUtc = function (date) {
    return new Date((typeof date === 'string' ? new Date(date) : date).toLocaleString('en-US', { timeZone: 'UTC' }));
};
exports.convertFromLocalToUtc = convertFromLocalToUtc;
var getTargetUserId = function () {
    return store2_1.default.session.getAll([Constants.impersonateInfo.targetUserId]).targetUserId;
};
exports.getTargetUserId = getTargetUserId;
var convertArrayToCSV = function (data) {
    var result;
    var columnDelimiter = ',';
    var lineDelimiter = '\n';
    var keys = Object.keys(data[0]);
    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;
    data.forEach(function (item) {
        var ctr = 0;
        keys.forEach(function (key) {
            if (ctr > 0)
                result += columnDelimiter;
            result += item[key];
            ctr++;
        });
        result += lineDelimiter;
    });
    return result;
};
var downloadCSV = function (data) {
    var link = document.createElement('a');
    var csv = convertArrayToCSV(data);
    if (csv == null)
        return;
    var filename = 'export.csv';
    if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8,".concat(csv);
    }
    link.setAttribute('href', encodeURI(csv));
    link.setAttribute('download', filename);
    link.click();
};
exports.downloadCSV = downloadCSV;
var getUserKey = function () {
    var userKeyFromCookie = js_cookie_1.default.get(Constants.UserKey);
    return (store2_1.default.session.getAll([Constants.impersonateInfo.targetUserKey]).targetUserKey ||
        userKeyFromCookie);
};
exports.getUserKey = getUserKey;
var setUserKey = function (userKey) {
    js_cookie_1.default.set(Constants.UserKey, userKey, { expires: 7 });
};
exports.setUserKey = setUserKey;
var setIsModernOrderingEnabled = function (isModernOrderingEnabled) {
    js_cookie_1.default.set(Constants.IsModernOrderingEnabled, "".concat(isModernOrderingEnabled), {
        expires: 1,
        domain: (0, CookieUtils_1.getCookieDomain)(),
    });
};
exports.setIsModernOrderingEnabled = setIsModernOrderingEnabled;
var getIsModernOrderingEnabled = function () {
    var isModernOrderingEnabledFromCookie = js_cookie_1.default.get(Constants.IsModernOrderingEnabled);
    return isModernOrderingEnabledFromCookie === 'true';
};
exports.getIsModernOrderingEnabled = getIsModernOrderingEnabled;
var getCurrentUserId = function () { return __awaiter(void 0, void 0, void 0, function () {
    var currentSession;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, auth_1.Auth.currentSession()];
            case 1:
                currentSession = _a.sent();
                return [2 /*return*/, JSON.parse(currentSession.getIdToken().payload['custom:toca_user_id'])];
        }
    });
}); };
exports.getCurrentUserId = getCurrentUserId;
var getJwtToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    var session;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, auth_1.Auth.currentSession()];
            case 1:
                session = _a.sent();
                return [2 /*return*/, session.getIdToken().getJwtToken()];
        }
    });
}); };
exports.getJwtToken = getJwtToken;
var getUserRoles = function () { return __awaiter(void 0, void 0, void 0, function () {
    var currentSession;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, auth_1.Auth.currentSession()];
            case 1:
                currentSession = _a.sent();
                return [2 /*return*/, JSON.parse(currentSession.getIdToken().payload['custom:roles'])];
        }
    });
}); };
var userHasRole = function (roleId) { return __awaiter(void 0, void 0, void 0, function () {
    var hasRole, roles;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                hasRole = false;
                return [4 /*yield*/, getUserRoles()];
            case 1:
                roles = _a.sent();
                roles.map(function (role) {
                    if (role.hasOwnProperty(roleId)) {
                        hasRole = true;
                    }
                });
                return [2 /*return*/, hasRole];
        }
    });
}); };
var setStateByRole = function (setStateCallBack, roleId) {
    userHasRole(roleId).then(function (value) {
        setStateCallBack(value);
    });
};
exports.setStateByRole = setStateByRole;
var formatDate = function (date, format) {
    return (0, dayjs_1.default)(date).format(format);
};
exports.formatDate = formatDate;
var addMonthsToDate = function (date, numberOfMonths) {
    var newDate = new Date(date);
    newDate.setMonth(date.getMonth() + numberOfMonths);
    return newDate;
};
exports.addMonthsToDate = addMonthsToDate;
var isImpersonating = function () {
    var _a = Constants.impersonateInfo, targetUserId = _a.targetUserId, targetUserKey = _a.targetUserKey, targetBrandId = _a.targetBrandId;
    var _b = store2_1.default.session.getAll([targetUserId, targetUserKey, targetBrandId]), userIdFromStore = _b.targetUserId, userKeyFromStore = _b.targetUserKey, brandIdFromStore = _b.targetBrandId;
    return !!userIdFromStore && !!userKeyFromStore && !!brandIdFromStore;
};
exports.isImpersonating = isImpersonating;
var getImpersonatingBrandId = function () {
    var _a;
    return (_a = js_cookie_1.default.get(Constants.AdminImpersonation.BrandIdCookieName)) !== null && _a !== void 0 ? _a : '';
};
exports.getImpersonatingBrandId = getImpersonatingBrandId;
var setImpersonatingBrandId = function (brandId) {
    if (!brandId) {
        js_cookie_1.default.remove(Constants.AdminImpersonation.BrandIdCookieName, {
            domain: (0, CookieUtils_1.getCookieDomain)(),
        });
    }
    else {
        js_cookie_1.default.set(Constants.AdminImpersonation.BrandIdCookieName, brandId, {
            domain: (0, CookieUtils_1.getCookieDomain)(),
        });
    }
};
exports.setImpersonatingBrandId = setImpersonatingBrandId;
var toLocalDate = function (utcDate) {
    return new Date(utcDate);
};
exports.toLocalDate = toLocalDate;
var isCurrentUserAdminOrSuperAdmin = function () { return __awaiter(void 0, void 0, void 0, function () {
    var currentSession, adminBrandId, isAdminRole;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, auth_1.Auth.currentSession()];
            case 1:
                currentSession = _a.sent();
                adminBrandId = '-1';
                isAdminRole = false;
                JSON.parse(currentSession.getIdToken().payload['custom:roles']).map(function (role) {
                    if (role.hasOwnProperty(UserRoles_1.UserRoles.Admin) || role.hasOwnProperty(UserRoles_1.UserRoles.SuperAdmin)) {
                        isAdminRole = true;
                    }
                });
                return [2 /*return*/, isAdminRole && currentSession.getIdToken().payload['custom:brand_id'] === adminBrandId];
        }
    });
}); };
exports.isCurrentUserAdminOrSuperAdmin = isCurrentUserAdminOrSuperAdmin;
var isCurrentUserOffshoreAdmin = function () { return __awaiter(void 0, void 0, void 0, function () {
    var currentSession;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, auth_1.Auth.currentSession()];
            case 1:
                currentSession = _a.sent();
                return [2 /*return*/, JSON.parse(currentSession.getIdToken().payload['custom:roles']).some(function (role) {
                        return role.hasOwnProperty(UserRoles_1.UserRoles.OffshoreAdminState) ||
                            role.hasOwnProperty(UserRoles_1.UserRoles.OffshoreAdminSector);
                    })];
        }
    });
}); };
exports.isCurrentUserOffshoreAdmin = isCurrentUserOffshoreAdmin;
var isCurrentUserCommsAdmin = function () { return __awaiter(void 0, void 0, void 0, function () {
    var currentSession, roles, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, auth_1.Auth.currentSession()];
            case 1:
                currentSession = _a.sent();
                roles = JSON.parse(currentSession.getIdToken().payload['custom:roles']);
                return [2 /*return*/, roles.some(function (role) { return role.hasOwnProperty(UserRoles_1.UserRoles.CommsAdmin); })];
            case 2:
                error_1 = _a.sent();
                console.error('Error fetching current session:', error_1);
                return [2 /*return*/, false];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.isCurrentUserCommsAdmin = isCurrentUserCommsAdmin;
var isCurrentUserSupplier = function () { return __awaiter(void 0, void 0, void 0, function () {
    var hasSupplierRole, currentSession, supplierEditorRole, supplierAdminRole, supplierSiteOrderManager, SupplierServiceCategoryAdmin;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                hasSupplierRole = false;
                return [4 /*yield*/, auth_1.Auth.currentSession()];
            case 1:
                currentSession = _a.sent();
                supplierEditorRole = UserRoles_1.UserRoles.SupplierEditor;
                supplierAdminRole = UserRoles_1.UserRoles.SupplierAdmin;
                supplierSiteOrderManager = UserRoles_1.UserRoles.SupplierSiteOrderManager;
                SupplierServiceCategoryAdmin = UserRoles_1.UserRoles.SupplierServiceCategoryAdmin;
                JSON.parse(currentSession.getIdToken().payload['custom:roles']).map(function (role) {
                    if (role.hasOwnProperty(supplierEditorRole) ||
                        role.hasOwnProperty(supplierAdminRole) ||
                        role.hasOwnProperty(supplierSiteOrderManager) ||
                        role.hasOwnProperty(SupplierServiceCategoryAdmin)) {
                        hasSupplierRole = true;
                    }
                });
                return [2 /*return*/, hasSupplierRole];
        }
    });
}); };
exports.isCurrentUserSupplier = isCurrentUserSupplier;
var isLoggedUserEnabledForLegacyRouting = function () { return __awaiter(void 0, void 0, void 0, function () {
    var enabledUsersForLegacyRouting, currentSession, loggedInUserKey;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                enabledUsersForLegacyRouting = [
                    'b7d9f4f8-7df8-4f7c-a0ea-4efce21c72fd',
                    '3a1d9d54-fbe9-4097-ac32-8c1a546d3a0a',
                    '1d8d1121-6a66-450c-a41a-91bb28a20a1f',
                    // the internal user in PROD
                    '25e39633-ef6f-4341-8b2c-7997bec04be2',
                    //for QA testing
                    '8b3090f5-9211-44cd-8c8c-35d9a95338a1',
                    '9448cf1b-150f-4106-bbc1-084a561d3eb7',
                ];
                return [4 /*yield*/, auth_1.Auth.currentSession()];
            case 1:
                currentSession = _a.sent();
                loggedInUserKey = currentSession.getIdToken().payload['custom:toca_user_key'];
                return [2 /*return*/, enabledUsersForLegacyRouting.includes(loggedInUserKey)];
        }
    });
}); };
exports.isLoggedUserEnabledForLegacyRouting = isLoggedUserEnabledForLegacyRouting;
var getLoggedInUserBrandId = function () { return __awaiter(void 0, void 0, void 0, function () {
    var currentSession, idToken;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, auth_1.Auth.currentSession()];
            case 1:
                currentSession = _a.sent();
                idToken = currentSession.getIdToken();
                return [2 /*return*/, idToken.payload['custom:brand_id']];
        }
    });
}); };
exports.getLoggedInUserBrandId = getLoggedInUserBrandId;
var isFlexiBrandUser = function () { return __awaiter(void 0, void 0, void 0, function () {
    var loggedUserBrandId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.getLoggedInUserBrandId)()];
            case 1:
                loggedUserBrandId = _a.sent();
                return [2 /*return*/, loggedUserBrandId === brandId_1.EBrandId.FLEXI || loggedUserBrandId === brandId_1.EBrandId.CDFPAY];
        }
    });
}); };
exports.isFlexiBrandUser = isFlexiBrandUser;
var isUserAdminOrSuperAdmin = function (setStateCallBack) {
    var adminRoleId = 1;
    var superAdminRoleId = 23;
    userHasRole(adminRoleId).then(function (value) {
        setStateCallBack(value);
        if (!value) {
            userHasRole(superAdminRoleId).then(function (value) {
                setStateCallBack(value);
            });
        }
    });
};
exports.isUserAdminOrSuperAdmin = isUserAdminOrSuperAdmin;
var isGuestUser = function () { return __awaiter(void 0, void 0, void 0, function () {
    var currentSession, idToken, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, auth_1.Auth.currentSession()];
            case 1:
                currentSession = _b.sent();
                idToken = currentSession.getIdToken();
                return [2 /*return*/, idToken.payload['custom:is_guest'].toString()];
            case 2:
                _a = _b.sent();
                return [2 /*return*/, false];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.isGuestUser = isGuestUser;
var getIsAccountOwner = function () {
    return js_cookie_1.default.get(Constants.isAccountOwner)
        ? JSON.parse(js_cookie_1.default.get(Constants.isAccountOwner))
        : false;
};
exports.getIsAccountOwner = getIsAccountOwner;
var formatMobileNumber = function (mobileNumber) {
    var x = mobileNumber && mobileNumber.replace(/\D/g, '').match(/(\d{0,4})(\d{0,3})(\d{0,4})/);
    return !x[2] ? x[1] : "".concat(x[1], " ").concat(x[2]).concat(x[3] ? " ".concat(x[3]) : '');
};
exports.formatMobileNumber = formatMobileNumber;
var getTargetedUserData = function () {
    var _a = Constants.impersonateInfo, targetUserId = _a.targetUserId, targetUserKey = _a.targetUserKey, targetBrandId = _a.targetBrandId;
    var impersonateStore = store2_1.default.session.getAll([targetUserId, targetUserKey, targetBrandId]);
    return impersonateStore;
};
exports.getTargetedUserData = getTargetedUserData;
var getStartOfDay = function (date) {
    return date ? (0, moment_1.default)(date).startOf('day') : (0, moment_1.default)().startOf('day');
};
exports.getStartOfDay = getStartOfDay;
var getEndOfDay = function (date) {
    return date ? (0, moment_1.default)(date).endOf('day') : (0, moment_1.default)().endOf('day');
};
exports.getEndOfDay = getEndOfDay;
var handleDayLightSavings = function (date) {
    return (0, moment_1.default)(date).subtract((0, moment_1.default)().isDST() ? 0 : 1, 'h');
};
exports.handleDayLightSavings = handleDayLightSavings;
var getAdminPortalRedirectionLink = function (adminBaseUrl, targetUserId) { return __awaiter(void 0, void 0, void 0, function () {
    var isUserAdminOrSuperAdmin, currentSession, userIdToken, tocaUserId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.isCurrentUserAdminOrSuperAdmin)()];
            case 1:
                isUserAdminOrSuperAdmin = _a.sent();
                if (!isUserAdminOrSuperAdmin) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, auth_1.Auth.currentSession()];
            case 2:
                currentSession = _a.sent();
                userIdToken = currentSession.getIdToken().getJwtToken();
                tocaUserId = currentSession.getIdToken().payload['custom:toca_user_id'];
                return [2 /*return*/, "".concat(adminBaseUrl, "api/users/").concat(tocaUserId, "/redirectadmin?returnUserId=").concat(targetUserId ? targetUserId : '', "&token=").concat(userIdToken)];
        }
    });
}); };
exports.getAdminPortalRedirectionLink = getAdminPortalRedirectionLink;
var getSsspRedirectionLink = function (ssspUrl, redirectUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var currentSession, userIdToken;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, auth_1.Auth.currentSession()];
            case 1:
                currentSession = _a.sent();
                userIdToken = currentSession.getIdToken().getJwtToken();
                return [2 /*return*/, "".concat(ssspUrl, "/api/identity/loginredirect?idToken=").concat(userIdToken, "&redirectUrl=").concat(ssspUrl, "/").concat(redirectUrl)];
        }
    });
}); };
exports.getSsspRedirectionLink = getSsspRedirectionLink;
var getRemainingTimeToOrder = function (date) {
    var totalTime = Date.parse(date) - Date.parse(new Date().toString());
    var minutes = Math.floor((totalTime / 1000 / 60) % 60);
    var hours = Math.floor((totalTime / (1000 * 60 * 60)) % 24);
    var days = Math.floor(totalTime / (1000 * 60 * 60 * 24));
    return {
        totalTime: totalTime,
        days: days,
        hours: hours,
        minutes: minutes,
    };
};
exports.getRemainingTimeToOrder = getRemainingTimeToOrder;
var getFormattedDateInUtc = function (date, format) {
    return !format
        ? (0, dayjs_1.default)(date)
            .utc(true)
            .format()
        : (0, dayjs_1.default)(date)
            .utc(true)
            .format(format);
};
exports.getFormattedDateInUtc = getFormattedDateInUtc;
var toFixedNumber = function (num, digits) {
    var pow = Math.pow(10, digits);
    return Math.round(num * pow) / pow;
};
exports.toFixedNumber = toFixedNumber;
function isSafari() {
    return navigator.userAgent.search('Safari') >= 0 && navigator.userAgent.search('Chrome') < 0;
}
var getLoggedInUserFullNameFromToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    var currentSession, firstName, lastName, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, auth_1.Auth.currentSession()];
            case 1:
                currentSession = _b.sent();
                firstName = currentSession.getIdToken().payload['given_name'];
                lastName = currentSession.getIdToken().payload['family_name'];
                return [2 /*return*/, firstName + ' ' + lastName];
            case 2:
                _a = _b.sent();
                return [2 /*return*/, ''];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getLoggedInUserFullNameFromToken = getLoggedInUserFullNameFromToken;
var getDetailDateFormate = function (dateS) {
    var date = new Date(dateS);
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    var hours = String(date.getHours()).padStart(2, '0');
    var minutes = String(date.getMinutes()).padStart(2, '0');
    var seconds = String(date.getSeconds()).padStart(2, '0');
    var formattedDate = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    return formattedDate;
};
exports.getDetailDateFormate = getDetailDateFormate;
var convertDateTimeToTimeZone = function (dateTimeSource, timeZoneSource, timeZoneTarget, formatTarget) {
    return dayjs_1.default
        .tz(dateTimeSource, timeZoneSource)
        .tz(timeZoneTarget)
        .format(formatTarget);
};
exports.convertDateTimeToTimeZone = convertDateTimeToTimeZone;
var showBrandSelector = function () {
    var domain = window.location.hostname;
    return domain.includes('qa.test.') || domain.includes('localhost') ? true : false;
};
exports.showBrandSelector = showBrandSelector;
var scrollToTop = function () {
    window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
    });
};
exports.scrollToTop = scrollToTop;
function deleteCookie(name) {
    document.cookie = "".concat(name, "=; max-age=0; path=/");
}
var clearAddItemsToServiceCookies = function () {
    deleteCookie(Constants.AddItemsToService.SupplierServiceKey);
};
exports.clearAddItemsToServiceCookies = clearAddItemsToServiceCookies;
var getAddItemsToServiceCookies = function () {
    return js_cookie_1.default.get(Constants.AddItemsToService.SupplierServiceKey) || '';
};
exports.getAddItemsToServiceCookies = getAddItemsToServiceCookies;
var setAddItemsToServiceCookies = function (supplierServiceKey) {
    (0, exports.clearAddItemsToServiceCookies)();
    js_cookie_1.default.set(Constants.AddItemsToService.SupplierServiceKey, supplierServiceKey, { expires: 1 });
};
exports.setAddItemsToServiceCookies = setAddItemsToServiceCookies;
var getCurrentYearAndUpdateToNextInDecember = function () {
    var displayedYear = (0, dayjs_1.default)().year();
    // months are 0 indexed so December is 11
    if ((0, dayjs_1.default)().month() == 11) {
        displayedYear = (0, dayjs_1.default)().year() + 1;
    }
    return displayedYear;
};
exports.getCurrentYearAndUpdateToNextInDecember = getCurrentYearAndUpdateToNextInDecember;
//# sourceMappingURL=AppUtils.js.map